/**
 * Archive of can.code projects with 2025 Q4+ activity.
 * Transcribed from ~/can.code/career/ENG_BRAIN/project-index.org.
 * Source is curated and manually maintained; update this file when
 * the org index changes.
 */

export interface ArchiveProject {
  name: string
  month: string
  description: string
  stack: string[]
  hasStarDoc?: boolean
  featured?: boolean
}

export const archiveProjects: ArchiveProject[] = [
  {
    name: 'jott / jot',
    month: '2026-05',
    description:
      'AI-powered interactive CLI project management tool with task management, ' +
      'calendar sync, keyword automation, and intelligent workflows. 72 modules, ' +
      '503 tests, published on PyPI.',
    stack: ['Python', 'Go', 'React Native'],
    hasStarDoc: true,
    featured: true,
  },
  {
    name: 'responder',
    month: '2026-04',
    description:
      'Real-time CLI tool that captures live audio, transcribes speech via ' +
      'AssemblyAI, and provides instant AI guidance through domain-specific ' +
      'agents. Sub-3-second latency.',
    stack: ['Python', 'AssemblyAI', 'Claude AI', 'CoreAudio'],
    hasStarDoc: true,
  },
  {
    name: 'project-universe',
    month: '2026-04',
    description:
      'Transforms project collection into an interconnected knowledge ecosystem ' +
      'by analyzing, categorizing, and extracting insights across 126+ projects.',
    stack: ['Node.js'],
  },
  {
    name: 'ShotList',
    month: '2026-04',
    description:
      'React Native mobile app for AI-guided video section planning and organized recording.',
    stack: ['React Native'],
  },
  {
    name: 'first-responder',
    month: '2026-04',
    description:
      'Native Android platform for live AI-powered voice assistance across ' +
      'switchable professional domains (medical coding, legal research). ' +
      'Domain-agnostic profile system.',
    stack: ['Kotlin', 'Jetpack Compose', 'Go', 'Next.js'],
    hasStarDoc: true,
    featured: true,
  },
  {
    name: 'inkwell',
    month: '2026-04',
    description:
      'Cross-platform desktop app for book writing combining voice recording, ' +
      'AI transcription, and 11 specialized writer agent personalities.',
    stack: ['Electron', 'Claude AI'],
  },
  {
    name: 'gitmore',
    month: '2026-04',
    description: 'Git extension library providing commands for managing multiple repositories at once.',
    stack: ['Shell/Bash'],
  },
  {
    name: 'resource-cli',
    month: '2026-04',
    description: 'CLI tool for reading Google Keep notes from the terminal.',
    stack: ['Python'],
  },
  {
    name: 'TubeNest',
    month: '2026-04',
    description:
      'Web app for parents to curate YouTube playlists for distraction-free, ' +
      'recommendation-free video viewing for children.',
    stack: ['Next.js', 'React'],
  },
  {
    name: 'PORTfolio',
    month: '2026-03',
    description:
      'Terminal-themed personal portfolio website with retro CRT aesthetic and ' +
      'interactive command-line interface. Hosted at sonander.dev.',
    stack: ['Next.js', 'React'],
  },
  {
    name: 'jobsearch-cli',
    month: '2026-03',
    description:
      'AI-powered CLI tool for searching jobs across multiple platforms, ' +
      'tracking applications, and intelligent job matching with browser ' +
      'extension for LinkedIn/Indeed.',
    stack: ['Go', 'Chrome Extension'],
    hasStarDoc: true,
    featured: true,
  },
  {
    name: 'action-viewer',
    month: '2026-03',
    description:
      'Keyboard-driven native macOS image viewer for quickly viewing and organizing ' +
      'images in directories.',
    stack: ['Swift'],
  },
  {
    name: 'bullet',
    month: '2026-03',
    description: 'Developer-focused CLI timer for maintaining time awareness during coding sessions.',
    stack: ['Python'],
  },
  {
    name: 'first-responder-web',
    month: '2026-03',
    description: 'Next.js web frontend for the FirstResponder platform.',
    stack: ['Next.js', 'React'],
  },
  {
    name: '4DV3N+',
    month: '2026-03',
    description: 'AI-powered CLI text adventure game where Claude acts as a fully autonomous dungeon master.',
    stack: ['Python', 'Claude AI'],
  },
  {
    name: 'YAPS',
    month: '2026-03',
    description:
      'Voice-first portfolio and development blog that showcases voice-AI ' +
      'capabilities through its own interface. AssemblyAI transcription, ' +
      'prompt engineering at scale.',
    stack: ['Next.js', 'AssemblyAI', 'Claude AI'],
    hasStarDoc: true,
    featured: true,
  },
  {
    name: 'fact-checker-extension',
    month: '2026-03',
    description:
      'Chrome extension for selecting text on any webpage and receiving AI-powered ' +
      'structured fact-check verdicts from Claude. Published on Chrome Web Store.',
    stack: ['JavaScript', 'Chrome Extension', 'Claude AI'],
    featured: true,
  },
  {
    name: 'interviewer',
    month: '2026-02',
    description: 'Real-time CLI tool for interview audio capture and AI guidance. Sibling of responder.',
    stack: ['Python', 'AssemblyAI', 'Claude AI'],
    featured: true,
  },
  {
    name: 'RxCoder',
    month: '2026-02',
    description:
      'Native Android app providing live AI-powered medical coding guidance via ' +
      'real-time audio transcription. Predecessor to FirstResponder.',
    stack: ['Kotlin', 'AssemblyAI', 'Claude AI'],
  },
  {
    name: 'project-memory-mcp',
    month: '2026-02',
    description:
      'MCP server providing Claude Code with queryable, structured memory across ' +
      'sessions using SQLite with full-text search.',
    stack: ['TypeScript', 'SQLite', 'MCP'],
  },
  {
    name: 'trumps_therapist',
    month: '2026-02',
    description:
      'Web app that fetches Trump quotes and provides AI-powered psychological ' +
      'analysis through a clinical psychology lens.',
    stack: ['Next.js', 'Claude AI'],
    featured: true,
  },
  {
    name: 'joe-friday',
    month: '2026-02',
    description:
      'Interactive CLI tool for performing web searches with multiple browser ' +
      'backends and official search APIs.',
    stack: ['Go'],
  },
  {
    name: 'prism',
    month: '2026-02',
    description:
      'Communication tool centered on autism, addressing the gap between how ' +
      'people communicate and how communication is interpreted.',
    stack: ['Next.js'],
  },
  {
    name: 'CAN-CODE-BIZ',
    month: '2026-02',
    description:
      'Community learning organization teaching AI capabilities together, creating ' +
      'open-source tools with accessibility-first design.',
    stack: ['Next.js'],
  },
  {
    name: 'career-portfolio-site',
    month: '2026-02',
    description: 'Professional portfolio website at sonander.dev.',
    stack: ['Next.js'],
  },
  {
    name: 'ash-tree-lane',
    month: '2026-01',
    description:
      'Episodic cross-platform video game inspired by House of Leaves, with unique ' +
      'narrative identity and interactive mechanics.',
    stack: ['Python'],
  },
  {
    name: 'password-gen',
    month: '2026-01',
    description:
      'Feature-rich CLI password generator with random passwords, XKCD-style ' +
      'passphrases, and entropy analysis.',
    stack: ['Python'],
  },
  {
    name: 'Chatterbox-TTS-Server',
    month: '2025-12',
    description: 'Text-to-speech server. Docker/PyTorch.',
    stack: ['Python', 'Docker', 'PyTorch'],
  },
  {
    name: 'jot-go',
    month: '2025-12',
    description: 'Go backend and React Native mobile app for jott. FastAPI, WebSocket sync, PostgreSQL.',
    stack: ['Go', 'React Native', 'PostgreSQL'],
  },
  {
    name: 'Ideanas',
    month: '2025-12',
    description: 'AI-powered idea generation platform with Stripe subscriptions.',
    stack: ['Next.js', 'Claude AI'],
    featured: true,
  },
  {
    name: 'house-of-leaves-game',
    month: '2025-11',
    description: 'Video game with AI-generated content integration. Related to ash-tree-lane.',
    stack: ['Python'],
  },
  {
    name: 'nostravision',
    month: '2025-11',
    description: 'Prediction and forecasting platform.',
    stack: ['Next.js'],
  },
  {
    name: 'StoryTimeStar',
    month: '2025-11',
    description: 'AI storytelling platform.',
    stack: ['Next.js', 'Claude AI'],
    featured: true,
  },
  {
    name: 'rubber-ducky-node',
    month: '2025-11',
    description: 'Node.js version of Rubber Ducky debugging platform. Index optimization.',
    stack: ['Node.js'],
  },
  {
    name: 'org-electron-reader',
    month: '2025-10',
    description: 'Electron app for reading org-mode files with "Open in Finder."',
    stack: ['Electron'],
  },
  {
    name: 'mini-llm',
    month: '2025-10',
    description: 'Training data service for small language model experiments.',
    stack: ['Python'],
  },
  {
    name: 'jot-log',
    month: '2025-10',
    description: 'Development dashboard with task scanner. Related to jott ecosystem.',
    stack: ['Python'],
  },
  {
    name: 'rubber-ducky-live',
    month: '2025-10',
    description: 'Real-time voice debugging platform. AssemblyAI v3 migration. Socket.IO.',
    stack: ['Next.js', 'AssemblyAI', 'Socket.IO'],
    featured: true,
  },
  {
    name: 'book-writing-prism',
    month: '2025-10',
    description: 'Next.js app for book writing. Became inkwell.',
    stack: ['Next.js'],
  },
  {
    name: 'job-application-automation',
    month: '2025-10',
    description: 'Rails 8 system for automated job applications with AI cover letters. Sidekiq.',
    stack: ['Ruby on Rails', 'Sidekiq'],
  },
  {
    name: 'can-code-biz-mcp',
    month: '2025-10',
    description: 'MCP server for CAN-CODE-BIZ ecosystem integration.',
    stack: ['MCP'],
  },
  {
    name: 'KITTana',
    month: '2025-09',
    description:
      'AI-powered automotive repair project management app. Gemini image analysis ' +
      'for part identification, condition assessment, and repair suggestions.',
    stack: ['Kotlin', 'Jetpack Compose', 'Google Gemini', 'Room DB', 'Ruby on Rails'],
    hasStarDoc: true,
  },
]

export function allStacks(projects: ArchiveProject[]): string[] {
  const set = new Set<string>()
  for (const p of projects) for (const s of p.stack) set.add(s)
  return Array.from(set).sort()
}

export function groupByMonth(projects: ArchiveProject[]): Map<string, ArchiveProject[]> {
  const groups = new Map<string, ArchiveProject[]>()
  for (const p of projects) {
    const list = groups.get(p.month) ?? []
    list.push(p)
    groups.set(p.month, list)
  }
  return new Map(Array.from(groups.entries()).sort((a, b) => b[0].localeCompare(a[0])))
}

export function formatMonth(yyyymm: string): string {
  const [year, mm] = yyyymm.split('-')
  const months = ['January', 'February', 'March', 'April', 'May', 'June',
                  'July', 'August', 'September', 'October', 'November', 'December']
  return `${months[Number(mm) - 1]} ${year}`
}
